<template>
    <VForm
        v-slot="validation"
        @submit="onSubmit">
        <div class="grid sm:grid-cols-1 gap-6">
            <div>
                <BaseNativeSelect
                    id="year"
                    v-model="yearId"
                    label="Jahr auswählen"
                    name="select_year"
                    class="relative flex flex-col flex-grow justify-end"
                    @update:model-value="checkYear()">
                    <option
                        v-for="storeYear in staticStore.years"
                        :key="storeYear.id"
                        :value="storeYear.id">
                        {{ storeYear.id }}
                    </option>
                </BaseNativeSelect>
            </div>
            <div>
                <BaseSwitch
                    v-model="createNewEvent"
                    :disabled="!changeNewEvent || yearId !== oldProcess.year_id"
                    :name="$t('processes.copy.copyWithNewEvent')"
                    :label="$t('processes.copy.copyWithNewEvent')"
                    :description="$t('processes.copy.copyWithNewEventDescription')" />
            </div>
            <div>
                <BaseInput
                    v-if="createNewEvent"
                    v-model="newEvent.name"
                    :label="$t('processes.copy.eventName')"
                    :placeholder="$t('processes.copy.eventName')"
                    required
                    :rules="{max: 255, required:true}" />
            </div>

            <div class="flex flex-col gap-y-2">
                <BaseSwitch
                    v-model="copyExecutedProgram"
                    :name="$t('processes.copy.copyExecutedProgram')"
                    :label="$t('processes.copy.copyExecutedProgram')"
                    :description="$t('processes.copy.copyExecutedProgramDescription')" />

                <BaseSwitch
                    v-model="copyDocuments"
                    :name="$t('processes.copy.copyDocuments')"
                    :label="$t('processes.copy.copyDocuments')"
                    :description="$t('processes.copy.copyDocumentsDescription')" />

                <BaseSwitch
                    v-if="createNewEvent"
                    v-model="copyPersons"
                    :name="$t('processes.copy.copyPersons')"
                    :label="$t('processes.copy.copyPersons')"
                    :description="$t('processes.copy.copyPersonsDescription')" />
            </div>
        </div>
        <BaseSubmitButtons
            :submit-label="$t('processes.copy.copyProcess')"
            :loading="loading"
            :validation="validation"
            @cancel="slideOverStore.resetSlideOver()" />
    </VForm>
</template>

<script setup>
import {useNuxtApp} from "nuxt/app"
import {useStatic} from "@/store/static"
import {$lara} from '@/utils/$larafetch'
import {useNotification} from "~/composables/useNotification"
import {useProcessGroupsStore} from "~/store/processGroups"
import {useSlideOverStore} from "~/store/slideOver"

const staticStore = useStatic()
const slideOverStore = useSlideOverStore()
const {$apiRoute} = useNuxtApp()
const notification = useNotification()
const app = useNuxtApp()
const {t: $t} = useI18n()
const useProcessGroups = useProcessGroupsStore()

const loading = ref(false)
const yearId = ref(staticStore.activeYear.id)
const oldEvent = computed(() => {
    return slideOverStore.context.event
})
const oldProcess = computed(() => {
    return slideOverStore.context.process
})

const changeNewEvent = ref(true)
const createNewEvent = ref(false)
const newEvent = ref({
    name: oldEvent.value.name
})
const copyExecutedProgram = ref(false)
const copyDocuments = ref(false)
const copyPersons = ref(false)

function checkYear() {
    if (yearId.value !== oldProcess.value.year_id) {
        createNewEvent.value = true
    }
}

function onSubmit() {
    loading.value = true
    $lara.post(
        $apiRoute('spa.processes.processes.copy'), {
            body: {
                oldProcessId: oldProcess.value.id,
                yearId: yearId.value,
                createNewEvent: createNewEvent.value,
                newEvent: createNewEvent.value ? newEvent.value : null,
                copyExecutedProgram: copyExecutedProgram.value,
                copyDocuments: copyDocuments.value,
                copyPersons: copyPersons.value,
            }
        }
    ).then(() => {
        slideOverStore.resetSlideOver()
        useProcessGroups.fetchProcessGroups()
        notification.success($t('processes.copy.copyProcessSuccess'))
    }).catch((error) => {
        if (error && error.response && error.response.status === 422) {
            notification.error(app.$i18n.t('invalidRequestData'))
        } else if (error && error.response && error.response.status === 404) {
            notification.error(app.$i18n.t('modelDoesNotExist'))
        } else {
            if (error && error.response?._data.message) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
            } else if (error && error.response?._data) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
            } else {
                notification.error(app.$i18n.t('generalRequestError'))
            }
        }
    }).finally(() => {
        loading.value = false
    })
}

onMounted(() => {
    let canOccurMultiple = true

    oldProcess.value.form_processes.forEach((formProcess) => {
        if (!formProcess.formable.multiple_occurrence_in_event) {
            canOccurMultiple = false
        }
    })

    if (!canOccurMultiple) {
        changeNewEvent.value = false
        createNewEvent.value = true
    } else {
        changeNewEvent.value = true
        createNewEvent.value = false
    }
})
</script>

<style scoped>

</style>